$(document).ready(function()
{
    
    function popupSingleCart()
    {
        var currentCartItems = localStorage.getItem('currentCartItems');

        var currentCartPrice = 0.00;
        var currentCartCount = 0;
        if (currentCartItems)
        {
            currentCartItems =  JSON.parse(currentCartItems);
        }
        else
        {
            currentCartItems = {};
        }

        updateSingleOrderCart();


        $('.quantity-selected-button').click(function(e)
        {
            var the_id = $(this).data('adjust-item');
            var the_sku = $(this).data('adjust-sku');
            var full_price = $(this).data('full-price');
            var the_title = $(this).data('adjust-title');
            var is_epionce = $(this).data('is-epionce');
            var delivery_charge = $(this).data('delivery-charge');
            var discount_pct = $(this).data('discount-pct');
            var actual_discount = $(this).data('actual-discount');
            var the_value = $("#quantity-selected-" + the_id).val();
            var the_outcome = $("#quantity-submitted-" + the_id);
            var the_link = $("#currentProductLink").html();

            the_outcome.val(the_value);
            modifySingleOrderCartItems(the_sku, the_title, the_value, full_price, is_epionce, delivery_charge, the_link, discount_pct, actual_discount);

            if (the_value > 0)
            {
              $(this).html("Update Basket");
            }
            else
            {
              $(this).html("Add to Basket"); 
            }

        });


        $('#cartPromptPreview').click(function(e)
        {
            $(this).parent().toggleClass("active");
        });


        $(document).on("click", ".cart-data-remove" , function() 
        {
            var removeSku = $(this).data('remove');
            removeFromSingleCart(removeSku);
        });

        function modifySingleOrderCartItems(sku, title, qty, full_price, is_epionce, delivery_charge, product_link, discount_pct, actual_discount)
        {
            qty = parseInt(qty);
            full_price = parseFloat(full_price);
            delivery_charge = parseFloat(delivery_charge);
            discount_pct = parseFloat(discount_pct);
            actual_discount = parseFloat(actual_discount);
            final_price = full_price - actual_discount;

            if (sku in currentCartItems)
            {
                if (qty > 0)
                {
                    var tempVars = 
                    {
                        qty : qty,
                        title : title,
                        full_price : full_price,
                        is_epionce : is_epionce,
                        delivery_charge : delivery_charge,
                        product_link : product_link,
                        discount_pct : discount_pct,
                        actual_discount : actual_discount,
                        final_price : final_price
                    }
                    currentCartItems[sku] = tempVars;

                }
                else
                {
                    delete currentCartItems[sku];
                }
            }
            else
            {
                if (qty > 0)
                {
                    var tempVars = 
                    {
                        qty : qty,
                        title : title,
                        full_price : full_price,
                        is_epionce : is_epionce,
                        delivery_charge : delivery_charge,
                        product_link : product_link,
                        discount_pct : discount_pct,
                        actual_discount : actual_discount,
                        final_price : final_price
                    }
                    currentCartItems[sku] = tempVars;
                }
            
            }
            updateSingleOrderCart();
        }

        function updateSingleOrderCart()
        {

            if ($('#cartPrompt').length)
            {
                var currentCount = 0;
                var currentPrice = 0.00;
                var echoString = '';
                
                for (var key in currentCartItems) 
                {
                    if (currentCartItems.hasOwnProperty(key)) 
                    {
                        currentCount += currentCartItems[key]['qty'];
                        var tmp_id = "#quantity-selected-" + key;
                        var tmp_num = currentCartItems[key]['qty'];
                        $(tmp_id).val(tmp_num); // reset the dropdown for this item
                        var calc = parseFloat(currentCartItems[key]['qty'] * currentCartItems[key]['final_price']);
                        if(isNaN(calc))
                        {}
                        else{
                            currentPrice += calc;
                        }

                    }

                    var bin_it = '<i class="fa fa-trash cart-data-remove" aria-hidden="true" data-remove="' + key + '"></i>';

                    echoString += "\n" + "<li>" + bin_it + currentCartItems[key]['qty'] + " x <a href=\"" + currentCartItems[key]['product_link'] + "\">" + currentCartItems[key]['title'] + "</a></li>";

                }    
                currentCartCount = currentCount;
                currentCartPrice = currentPrice;
                $("#cartPromptCounter").html(currentCartCount);
                $("#cartPromptPrice").html(SharedUtils.currencyFormat(parseFloat(currentCartPrice)));
                $("#cartPromptItems").html(echoString);
                $('#cartPromptFull .button').slideDown();
                $("#cartCountActive").html(currentCartCount);

                if (currentCartPrice > SharedConfig.maximumBasketValue || currentCount > SharedConfig.maximumBasketUnits )
                {
                    var warningMsg = '';
                    if (currentCartPrice > SharedConfig.maximumBasketValue)
                    {
                        warningMsg = "The maximum value permitted for a transaction is " + SharedUtils.maxBasketValueStr() + ". Please remove some items.";
                    }
                    else
                    {
                        warningMsg = "The maximum number of products you can purchase in a single transaction is " + SharedConfig.maximumBasketUnits + ". Please remove some items.";
                    }

                    $('#promptMaxValuesWarning .warningMsg').html(warningMsg);
                    $('#promptCheckoutButton').addClass('disabled-btn');
                    $('#promptMaxValuesWarning').slideDown();
                }
                else
                {
                    $('#promptMaxValuesWarning .warningMsg').html("");
                    $('#promptCheckoutButton').removeClass('disabled-btn');
                    $('#promptMaxValuesWarning').slideUp();
                }

                localStorage.removeItem('currentCartItems');
                localStorage.setItem('currentCartItems', JSON.stringify(currentCartItems));
                if (currentCartCount == 0)
                {
                    $('#cartPrompt').removeClass("active");
                    $('#cartPrompt   .button').slideUp();
                    $("#cartCountActive").html("");  
                }

            }

        }

        function removeFromSingleCart(sku)
        {
            delete currentCartItems[sku];
            var tmp_id = "#quantity-selected-" + sku;
            $(tmp_id).val(0); // reset the dropdown for this item
            updateSingleOrderCart();
        }


    };

    if ( $('#singleProductBlock').length )
    {
        popupSingleCart();
    }



});